import React, { useState, Fragment, useEffect } from 'react'
import Flex from 'components/Flex'
import CheckedWhite from 'components/icons/CheckedWhite'
import Button from 'components/Button/index'
import Control from 'components/Control/Control'
import {
  SectionWrapper,
  TopHeader,
  TopHeading,
  TabDiv,
  ImageUploadWrapper,
  ImageTag,
  FormItem,
  InputLabel,
  ImageColPadding,
  ButtonCenterPadding,
  RowPadding,
  LabelColPadding,
  StyledSelectDiv,
  StyledInput,
  StyledInputDiv,
  MessageDiv,
  StyledTabs,
  ChangeSpan,
  ImageFlex,
} from 'modules/ManageProfile/Styles/style'
import Label from 'components/Label/Label'
import AntdSelect from 'components/Form/Select'
import { Tabs, Row, Col, Switch, Form } from 'antd'
import Camera from 'components/icons/Camera'
import LockIcon from 'components/icons/LockIcon'
import Uploader from 'components/Uploader/ImageUploader'
import AntdInput from 'components/Form/Input'
import Password from 'components/Form/Password'
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons'
import SuccessMessage from 'utils/SuccessMessage'
import ErrorMessage from 'utils/ErrorMessage'
import { encrypt } from 'utils/encrypt'
import ChangePhoneNum from 'modules/ManageProfile/Components/PhoneModel/index'

const { TabPane } = Tabs
const ManageProfile = ({
  userId,
  changePassword,
  getUserRoles,
  userData,
  userRole,
  updateNotification,
  checkOtp,
  SendOtp,
  updateUserData,
  getUserInfo,
  deleteFile,
}) => {
  const [file, setFile] = useState(null)
  const [submitkey, setSubmitkey] = useState('profileForm')
  const [phoneModel, setPhoneModel] = useState(false)
  const [phoneOTP, setPhoneOTP] = useState(false)
  const [phoneVerify, setPhoneVerify] = useState(false)
  const [enteredPhone, setEnteredPhone] = useState()

  const [form] = Form.useForm()
  const [formPwd] = Form.useForm()
  const [formsetting] = Form.useForm()
  const formRef = React.createRef()
  const [email, setEmail] = useState()
  const [whatsapp, setWhatsapp] = useState()

  useEffect(() => {
    getUserRoles()
  }, [])

  useEffect(() => {
    form.setFieldsValue({
      profilePicture: userData?.profile_picture,
      firstName: userData?.first_name,
      lastName: userData?.last_name,
      email: userData?.email,
      role: getRoleName(
        userData?.pluginlive_id
          ? userData?.admin?.roleId
          : userData?.admin_role_id ?? userData?.role_id
      ),
      phoneNumber: userData?.phone_number,
    })
    setFile(userData?.profile_picture || null)
    formsetting.setFieldsValue({
      whatsapp: userData?.notification_subscription?.whatsapp,
      email: userData?.notification_subscription?.email,
    })

    setEmail(userData?.notification_subscription?.email)
    setWhatsapp(userData?.notification_subscription?.whatsapp)
  }, [userData])

  useEffect(() => {
    form.setFieldsValue({ profilePicture: file || '' })
  }, [file])

  const getRoleName = id => {
    let roleName = userRole?.filter(data => data?.id === id)[0]?.name
    return roleName ?? '-'
  }

  const submitHandler1 = async values => {
    let firstName = values?.firstName?.trim()
    let lastName = values?.lastName?.trim()
    let payload = {
      firstName: firstName,
      lastName: lastName,
      profilePicture: values?.profilePicture || null,
    }

    let response = await updateUserData(payload)

    if (response?.status >= 200 && response?.status <= 300) {
      SuccessMessage('Personal info saved successfully!')
      getUserInfo()
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }
  const alphabeticRegex = /^[A-Za-z\s]+$/

  const submitHandler2 = async values => {
    let payload = {
      currentPassword: await encrypt(values.currentPwd),
      newPassword: await encrypt(values.newPwd),
    }
    if (values.confirmPwd === values.newPwd) {
      let response = await changePassword(payload)

      if (response.status >= 200 && response.status < 300) {
        formPwd.resetFields()
        SuccessMessage('Password Changed Successfully')
      } else if (values.currentPwd === values.confirmPwd) {
        ErrorMessage(response?.response?.data?.message?.message)
      } else {
        ErrorMessage(response?.response?.data?.message?.message)
      }
    } else {
      formRef.current.setFields([
        {
          name: 'confirmPwd',
          errors: [
            'Passwords do not match. Please make sure they match exactly',
          ],
        },
      ])
    }
  }

  const submitHandler3 = async values => {
    let value1 = email
    let value2 = whatsapp
    let payload = {
      email: value1,
      whatsapp: value2,
    }
    const response = await updateNotification(payload)
    if (response) {
      SuccessMessage('Notification Updated Successfully')
      // getUserInfo()
    } else {
      ErrorMessage(response?.response?.data?.message)
    }
  }

  const onChangeEmail = checked => setEmail(checked)
  const onChangeWhatsapp = checked => setWhatsapp(checked)

  const onPhoneEntered = e => {
    setEnteredPhone(e.target.value)
  }

  const onRemoveImage = async () => {
    let response = await deleteFile(file)
    if (response) {
      setFile(null)
      form.setFieldsValue({ profilePicture: '' })
      SuccessMessage('File deleted successfully!')
    } else {
      ErrorMessage('Failed to delete the file!')
    }
  }

  const PhoneData = [
    {
      id: 1,
      name: '+91',
      value: '+91',
    },
    {
      id: 2,
      name: '+1',
      value: '+1',
    },
  ]

  const changePhone = () => {
    setPhoneModel(true)
  }

  const onChange = key => {
    setSubmitkey(key)
  }

  return (
    <>
      <SectionWrapper column>
        <TopHeader row spaceBetween alignCenter>
          <TopHeading flexStart>Manage Profile</TopHeading>
          <Flex>
            <Button.Primary
              icon={<CheckedWhite />}
              height="32px"
              htmlType="submit"
              text={'Save Changes'}
              width={'144px'}
              form={submitkey}
            />
          </Flex>
        </TopHeader>
        <TabDiv>
          <StyledTabs defaultActiveKey={submitkey} onChange={onChange}>
            <TabPane tab="Profile Settings" key="profileForm">
              <Form
                x
                onFinish={submitHandler1}
                id={'profileForm'}
                form={form}
                layout="vertical"
              >
                <Row>
                  <ImageFlex row centerVertically>
                    <ImageColPadding>
                      <ImageUploadWrapper column alignCenter center>
                        {!file && (
                          <Fragment>
                            <Control column alignCenter>
                              <Camera />
                            </Control>
                            <Control column alignCenter top={'3px'}>
                              <Control column alignCenter>
                                Max file size: 2MB
                              </Control>
                              <Control column alignCenter>
                                Dimension: 130*130
                              </Control>
                              <Control column alignCenter>
                                File format: .png, .jpeg
                              </Control>
                            </Control>
                          </Fragment>
                        )}

                        {file && <ImageTag src={file} />}
                      </ImageUploadWrapper>

                      {!file && (
                        <Uploader
                          setFile={setFile}
                          showTextUploder={!file}
                          fileName={
                            userData?.first_name
                              ?.toLowerCase()
                              .replace(/\s/g, '') + '_profile'
                          }
                        />
                      )}
                      <FormItem
                        name={'profilePicture'}
                        padding={true}                        
                      />
                    </ImageColPadding>

                    <ButtonCenterPadding>
                      {file ? (
                        <Flex>
                          <Uploader
                            isDelete={true}
                            file={file}
                            setFile={setFile}
                            showButtonUploder={file}
                            fileName={
                              userData?.first_name
                                ?.toLowerCase()
                                .replace(/\s/g, '') + '_profile'
                            }
                          />
                          &nbsp; &nbsp;
                          <Button.Secondary
                            text="Remove"
                            onClick={onRemoveImage}
                            height={'32px'}
                            width="76px"
                          />
                        </Flex>
                      ) : null}
                    </ButtonCenterPadding>
                  </ImageFlex>
                </Row>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>First Name</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <AntdInput
                      placeholder="First name"
                      name={'firstName'}
                      maxLength={120}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter first name!',
                        },
                        {
                          pattern: alphabeticRegex,
                          message: 'First name must contain only letters!',
                        },
                      ]}
                    />
                  </Col>
                </RowPadding>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>Last Name</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <AntdInput
                      placeholder="Last name"
                      name={'lastName'}
                      maxLength={20}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter last name!',
                        },
                        {
                          pattern: alphabeticRegex,
                          message: 'Last name must contain only letters!',
                        },
                      ]}
                    />
                  </Col>
                </RowPadding>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <Label>Email ID</Label>
                  </LabelColPadding>
                  <Col span={10}>
                    <AntdInput
                      placeholder="eg:harry@yahoo.com"
                      name={'email'}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter primary email!',
                        },
                      ]}
                      suffix={<LockIcon />}
                      disabled={true}
                    />
                  </Col>
                </RowPadding>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <Label>Role</Label>
                  </LabelColPadding>
                  <Col span={10}>
                    <AntdInput
                      placeholder="Role"
                      name={'role'}
                      rules={[
                        {
                          required: true,
                          message: 'Please enter role',
                        },
                      ]}
                      suffix={<LockIcon />}
                      disabled={true}
                    />
                  </Col>
                </RowPadding>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <Label>Phone Number</Label>
                  </LabelColPadding>
                  <Col span={10}>
                    <Control>
                      <StyledSelectDiv>
                        <AntdSelect
                          OptionData={PhoneData}
                          width="100%"
                          nameParam="value"
                          bordered={false}
                          placeholder="+91"
                        />
                      </StyledSelectDiv>
                      <StyledInputDiv>
                        <StyledInput
                          width="100%"
                          type="tel"
                          placeholder="Eg: 1010101010"
                          rules={[
                            {
                              required: true,
                              message: 'Please Enter phone number!',
                            },
                          ]}
                          name={'phoneNumber'}
                          disabled={true}
                          suffix={
                            <ChangeSpan onClick={changePhone}>
                              Change
                            </ChangeSpan>
                          }
                        />
                      </StyledInputDiv>
                    </Control>
                  </Col>
                </RowPadding>
              </Form>
            </TabPane>
            <TabPane tab="Change Password" key="ChangePasswordForm">
              <Form
                scrollToFirstError
                onFinish={submitHandler2}
                id={'ChangePasswordForm'}
                form={formPwd}
                ref={formRef}
                layout="vertical"
              >
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>Current Password</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <Password
                      placeholder="Enter Current Password"
                      name="currentPwd"
                      type="password"
                      maxLength={20}
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value) {
                              return Promise.reject(
                                new Error('Please Enter Current Password.')
                              )
                            }

                            if (value.length < 8) {
                              return Promise.reject(
                                new Error(
                                  'Password must be at least 8 characters long.'
                                )
                              )
                            }

                            const letterRegex = /[a-zA-Z]/
                            const numberRegex = /[\d]/
                            const symbolRegex =
                              /[!@#$%^&*()_+[\]{};:'",.<>?/\\|`~\-]/

                            if (
                              !letterRegex.test(value) ||
                              !numberRegex.test(value) ||
                              !symbolRegex.test(value)
                            ) {
                              return Promise.reject(
                                new Error(
                                  'Password must contain at least 1 letter, 1 number, and 1 symbol.'
                                )
                              )
                            }

                            return Promise.resolve()
                          },
                        }),
                      ]}
                      iconRender={visible =>
                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                      }
                    />
                  </Col>
                </RowPadding>
                <MessageDiv>
                  Password should be alphanumeric with special characters.
                </MessageDiv>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>New Password</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <Password
                      placeholder="Enter New Password"
                      name={'newPwd'}
                      maxLength={20}
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value) {
                              return Promise.reject(
                                new Error('Please Enter New Password.')
                              )
                            }

                            if (value.length < 8) {
                              return Promise.reject(
                                new Error(
                                  'Password must be at least 8 characters long.'
                                )
                              )
                            }

                            const letterRegex = /[a-zA-Z]/
                            const numberRegex = /[\d]/
                            const symbolRegex =
                              /[!@#$%^&*()_+[\]{};:'",.<>?/\\|`~\-]/

                            if (
                              !letterRegex.test(value) ||
                              !numberRegex.test(value) ||
                              !symbolRegex.test(value)
                            ) {
                              return Promise.reject(
                                new Error(
                                  'Password must contain at least 1 letter, 1 number, and 1 symbol.'
                                )
                              )
                            }

                            return Promise.resolve()
                          },
                        }),
                      ]}
                      iconRender={visible =>
                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                      }
                    />
                  </Col>
                </RowPadding>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>Confirm Password</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <Password
                      placeholder="Confirm Password"
                      name={'confirmPwd'}
                      maxLength={20}
                      rules={[
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (!value) {
                              return Promise.reject(
                                new Error('Please Enter Confirm Password')
                              )
                            }

                            if (value.length < 8) {
                              return Promise.reject(
                                new Error(
                                  'Password must be at least 8 characters long.'
                                )
                              )
                            }

                            const letterRegex = /[a-zA-Z]/
                            const numberRegex = /[\d]/
                            const symbolRegex =
                              /[!@#$%^&*()_+[\]{};:'",.<>?/\\|`~\-]/

                            if (
                              !letterRegex.test(value) ||
                              !numberRegex.test(value) ||
                              !symbolRegex.test(value)
                            ) {
                              return Promise.reject(
                                new Error(
                                  'Password must contain at least 1 letter, 1 number, and 1 symbol.'
                                )
                              )
                            }

                            return Promise.resolve()
                          },
                        }),
                      ]}
                      iconRender={visible =>
                        visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                      }
                    />
                  </Col>
                </RowPadding>
              </Form>
            </TabPane>
            <TabPane tab="Notification Settings" key="settingForm">
              <Form
                scrollToFirstError
                onFinish={submitHandler3}
                id={'settingForm'}
                form={formsetting}
                layout="vertical"
              >
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>Email Notification</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <Switch
                      name={'email'}
                      onChange={onChangeEmail}
                      checked={email}
                    />
                  </Col>
                </RowPadding>
                <RowPadding>
                  <LabelColPadding span={6}>
                    <InputLabel>Whatsapp Notification</InputLabel>
                  </LabelColPadding>
                  <Col span={10}>
                    <Switch
                      name={'whatsapp'}
                      onChange={onChangeWhatsapp}
                      checked={whatsapp}
                    />
                  </Col>
                </RowPadding>
              </Form>
            </TabPane>
          </StyledTabs>
        </TabDiv>
      </SectionWrapper>

      <ChangePhoneNum
        phoneOTP={phoneOTP}
        setPhoneOTP={setPhoneOTP}
        phoneVerify={phoneVerify}
        setPhoneVerify={setPhoneVerify}
        phoneModel={phoneModel}
        setPhoneModel={setPhoneModel}
        onPhoneEntered={onPhoneEntered}
        enteredPhone={enteredPhone}
        SendOtp={SendOtp}
        checkOtp={checkOtp}
        userId={userId}
        getUserInfo={getUserInfo}
        setenteredPhone={setEnteredPhone}
        userData={userData}
      />
    </>
  )
}
export default ManageProfile
